var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnverifiedDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 21,
    height: 21,
    rx: 2.8,
    fill: "#505463"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.859,
    y: -0.7,
    width: 21,
    height: 21,
    rx: 2.8,
    transform: "rotate(45 13.86 -.7)",
    fill: "#505463"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.758 14.438l3.267 3.266 6.533-6.533",
    stroke: "#2E3343",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMy41IiB5PSIzLjUiIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgcng9IjIuOCIgZmlsbD0iIzUwNTQ2MyIvPgo8cmVjdCB4PSIxMy44NTk0IiB5PSItMC43MDAxOTUiIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgcng9IjIuOCIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTMuODU5NCAtMC43MDAxOTUpIiBmaWxsPSIjNTA1NDYzIi8+CjxwYXRoIGQ9Ik05Ljc1NzgxIDE0LjQzNzZMMTMuMDI0NSAxNy43MDQyTDE5LjU1NzggMTEuMTcwOSIgc3Ryb2tlPSIjMkUzMzQzIiBzdHJva2Utd2lkdGg9IjIuMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgUnverifiedDark as ReactComponent };